// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u96O","footer":"styles_footer__pYSFL","passCodeTooltip":"styles_passCodeTooltip__30KZu"};